// src/services/ImprimirService.js
import api from '../api/axiosInstance';

export const obtenerNumeroTicket = async () => {
    try {
        const response = await api.get('/personal/impresion');
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al obtener número de ticket' };
    }
};

export const confirmarNumeroTicket = async () => {
    try {
        await api.post('/personal/confirmar-impresion');
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al confirmar impresión de ticket' };
    }
};
